import ApiService from '@/common/api.service';
import Toast from '@/common/toast';

const resource = 'folders';

const FolderService = {
    async queryRoot() {
        return ApiService.get('subfolders');
    },
    async queryByParentFolder(parentfolder) {
        return ApiService.get('subfolders', parentfolder);
    },
    async create(parentfolder, folderName) {
        let promise = null;
        try {
            let newFolder = { folderName };

            if (parentfolder != null) {
                newFolder.parent = parentfolder;
            }

            promise = await ApiService.put(resource, newFolder);
            Toast.showCreateOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
    async update(folder) {
        let promise = null;
        try {
            promise = await ApiService.put(resource, folder);
            Toast.showCreateOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
};

export default FolderService;
